import SearchSelect from '../SearchSelect'
import { searchFilter } from '../../utils'
import React from 'react'
import { connect } from 'react-redux'
import actions from '../../reducers/actions'

const getTypeOptions = ({ vendors, crews, users, events }, type) => {
  switch (type) {
  case 'vendor':
    return vendors.map(vendor => ({ label: vendor.VendorName, value: vendor.VendorID, ...vendor }))
  case 'crews':
    return crews.map(crew => ({ label: crew.CrewName, value: crew.CrewID, ...crew }))
  case 'user':
    return users.map(user => ({ label: user.Username, value: user.Username, ...user }))
  case 'event':
    return events.map(event => ({ label: event.Evt_Name, value: event.EventID, ...event }))
  case 'boolean':
    return [{ label: 'Yes', value: true }, { label: 'No', value: false }]
  default:
    return []
  }
}

const mapOptionsToProps = (state, ownProps) => {
  const options = [{ value: null, label: 'Null' }]
    .concat(getTypeOptions({ ...state.user, ...state.data }, ownProps.colInfo.type))
  return { options, ...ownProps }
}

export const AsyncSelectPickerFilter = connect(mapOptionsToProps, actions)(({
  column: { name: columnName },
  options,
  filter,
  handleFilterChanged
}) => {
  const value = filter && filter.value.map(f => options.find(o => o.value === f.value))
  
  const onChange = values => {
    handleFilterChanged({
      columnName: columnName,
      value: values || null
    })
  }
  
  return (
    <SearchSelect
      async
      isMulti
      fitContent
      hideIcon
      placeholder="Filter..."
      hideSelectedOptions={false}
      defaultOptions={options.slice(0, 50)}
      loadOptions={searchFilter(options)}
      style={{
        minWidth: 'unset'
      }}
      {...{ value, onChange }}
    />
  )
})